var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHypefitInline(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      paintOrder: "fill",
      strokeWidth: 0
    },
    d: "M 18.138 25.555 L 18.138 37.636 L 69.007 37.636 L 69.007 25.555 L 18.138 25.555 Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      paintOrder: "fill",
      strokeWidth: 0
    },
    d: "M 73.458 25.555 L 85.54 25.555 L 85.54 53.533 L 30.855 53.533 L 30.855 69.43 L 18.138 69.43 L 18.138 41.452 L 73.458 41.452 L 73.458 25.555 Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      paintOrder: "fill",
      strokeWidth: 0
    },
    d: "M 34.671 57.348 L 85.54 57.348 L 85.54 69.43 L 34.671 69.43 L 34.671 57.348 Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      paintOrder: "fill",
      strokeWidth: 0
    },
    d: "M 127.67 28.06 L 137.84 28.06 L 137.84 42.752 L 155.922 42.752 L 155.922 28.06 L 166.093 28.06 L 166.093 67.614 L 155.922 67.614 L 155.922 52.922 L 137.84 52.922 L 137.84 67.614 L 127.67 67.614 L 127.67 28.06 Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      paintOrder: "fill",
      strokeWidth: 0
    },
    d: "M 185.325 28.06 L 185.303 45.012 C 185.303 50.662 189.825 52.922 194.344 52.922 L 215.816 52.922 L 215.816 58.572 C 215.816 58.572 206.775 58.572 203.386 58.572 C 198.865 58.572 196.605 61.963 196.605 64.224 L 196.605 67.614 L 216.946 67.614 C 223.727 67.614 225.988 61.963 225.988 58.572 L 225.988 28.06 L 215.816 28.06 L 215.816 42.752 L 195.476 42.752 L 195.476 28.06 L 185.325 28.06 Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      paintOrder: "fill",
      strokeWidth: 0
    },
    d: "M 245.199 28.06 L 245.199 67.614 L 255.369 67.614 L 255.369 28.06 L 245.199 28.06 Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      paintOrder: "fill",
      strokeWidth: 0
    },
    d: "M 254.24 37.101 L 275.712 37.101 L 277.972 38.232 C 277.972 38.232 278.034 41.559 277.972 41.622 C 277.909 41.684 275.712 42.752 275.712 42.752 L 254.24 42.752 L 254.24 51.793 C 254.24 51.793 254.24 51.793 279.102 51.793 C 284.752 51.793 287.013 47.271 287.013 45.012 C 287.013 45.012 287.013 45.012 287.013 35.97 C 287.013 30.321 282.493 28.06 279.102 28.06 C 270.814 28.06 254.24 28.06 254.24 28.06 C 254.24 28.06 254.24 37.427 254.24 37.101 Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      paintOrder: "fill",
      strokeWidth: 0
    },
    d: "M 305.093 28.06 L 345.776 28.06 L 345.776 37.101 C 345.776 37.101 314.134 36.987 314.134 37.101 C 314.134 37.215 314.134 43.881 314.134 43.881 L 345.776 43.881 C 345.776 43.881 345.89 51.793 345.776 51.793 C 345.662 51.793 314.134 51.793 314.134 51.793 L 314.134 58.572 L 345.776 58.572 C 345.776 58.572 345.89 67.614 345.776 67.614 C 345.662 67.614 305.093 67.614 305.093 67.614 L 305.093 28.06 Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      paintOrder: "fill",
      strokeWidth: 0
    },
    d: "M 366.091 28 L 366.118 67.614 L 371.77 67.614 L 371.77 50.662 L 395.499 50.662 C 395.499 50.662 395.727 44.898 395.499 45.012 C 395.272 45.125 371.77 45.012 371.77 45.012 L 371.77 32.581 L 400.02 32.581 L 400.02 28.06 L 366.091 28 Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      paintOrder: "fill",
      strokeWidth: 0
    },
    d: "M 420.362 28.06 L 426.012 28.06 L 426.012 67.614 L 420.362 67.614 L 420.362 28.06 Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      paintOrder: "fill",
      strokeWidth: 0
    },
    d: "M 445.224 28.06 L 445.224 33.712 L 462.175 33.712 L 462.175 67.614 L 467.826 67.614 L 467.826 33.712 L 483.647 33.712 L 483.647 28.06 L 445.224 28.06 Z"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHypefitInline);
export default __webpack_public_path__ + "static/media/hypefit-inline.f5f179a80ace6f770e161c449f4b96fd.svg";
export { ForwardRef as ReactComponent };